var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card w-100" }, [
    _c(
      "div",
      {
        staticClass: "card-header sticky-top",
        class: { "--smaller-title": _vm.smallerTitle }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "h4",
              [
                _c("EhrIcon", { attrs: { icon: _vm.cardIcon, primary: "" } }, [
                  _vm._v(_vm._s(_vm.cardTitle))
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.hasExtraHeaderContentSlot
            ? _c(
                "div",
                { staticClass: "col" },
                [_vm._t("extraHeaderContent")],
                2
              )
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _vm.isLoading
          ? _c("div", { staticClass: "text-center" }, [
              _c("div", { staticClass: "spinner-border text-primary" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    ),
    _vm._v(" "),
    _vm.hasFooterContentSlot
      ? _c(
          "div",
          { staticClass: "text-center card-footer" },
          [_vm._t("footerContent")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }